import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function WhatsAppIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.42-.07-.12-.27-.2-.57-.35zM12.05 21.5h-.01a9.45 9.45 0 0 1-4.82-1.32l-.35-.2-3.58.94.96-3.49-.23-.36a9.43 9.43 0 0 1-1.45-5.03c0-5.22 4.25-9.47 9.48-9.47a9.4 9.4 0 0 1 6.7 2.78 9.42 9.42 0 0 1 2.77 6.7c0 5.22-4.25 9.46-9.47 9.46zm8.06-17.52A11.32 11.32 0 0 0 12.05.64C5.77.64.66 5.75.66 12.03c0 2.01.52 3.97 1.52 5.7L.56 23.64l6.04-1.58a11.37 11.37 0 0 0 5.44 1.39h.01c6.28 0 11.39-5.11 11.39-11.39 0-3.04-1.19-5.9-3.33-8.05z" />
    </svg>
  );
}

function TipIcon({ label, testId, children, className, tipRight, ...rest }) {
  const Tag = rest.href ? "a" : "button";
  return (
    <span className="relative group">
      <Tag {...rest} aria-label={label} data-testid={testId} {...(Tag === "button" ? { type: "button" } : {})}
        className={`grid place-items-center w-11 h-11 rounded-full transition-colors ${className}`}>
        {children}
      </Tag>
      <span role="tooltip" data-testid={`${testId}-tooltip`} className={`pointer-events-none absolute ${tipRight ? "right-0" : "left-1/2 -translate-x-1/2"} bottom-full mb-1.5 z-20 whitespace-nowrap rounded-md bg-foreground px-2 py-1 text-xs font-medium text-background shadow-md hidden group-hover:block group-active:block`}>{label}</span>
    </span>
  );
}

export function MaestroWhatsApp({ endpoint, text, tipRight }) {
  const { user } = useAuth();
  const [phone, setPhone] = useState(null);
  const eligible = user?.role === "customer" && !!user?.phone;
  useEffect(() => {
    setPhone(null);
    if (!eligible) return;
    api.get(endpoint).then((r) => setPhone(r.data.phone)).catch(() => {});
  }, [eligible, endpoint]);
  if (!phone) return null;
  return (
    <TipIcon label="Pregunta al Maestro (Whatsapp)" testId="ask-maestro-whatsapp" tipRight={tipRight} target="_blank" rel="noopener noreferrer"
      href={`https://wa.me/${phone.replace(/\D/g, "")}?text=${encodeURIComponent(text)}`} className="bg-[#25D366]/15 text-[#128C7E] hover:bg-[#25D366]/25">
      <WhatsAppIcon className="w-5 h-5" />
    </TipIcon>
  );
}

export function AskMaestroActions({ workshop, onInternal }) {
  return (
    <div className="flex items-center justify-center gap-3 pt-1" data-testid="ask-maestro-actions">
      <span className="text-sm text-muted-foreground">¿Dudas? Pregunta al Maestro</span>
      <TipIcon label="Pregunta al Maestro (mensaje interno)" testId="ask-maestro-btn" onClick={onInternal}
        className="bg-primary/10 text-primary hover:bg-primary/20">
        <MessageCircle className="w-5 h-5" />
      </TipIcon>
      <MaestroWhatsApp endpoint={`/workshops/${workshop.id}/whatsapp`} tipRight
        text={`Hola, tengo una consulta sobre el taller «${workshop.name}» que vi en VIVOTaller.`} />
    </div>
  );
}
